import React from 'react';

/** Inline spinner + label for a button the user just clicked. */
export default function ButtonBusyLabel({ children }) {
  return (
    <span className="btn-busy-label">
      <span className="btn-busy-spinner" aria-hidden="true" />
      <span>{children}</span>
    </span>
  );
}
